import { taxaOptions } from '../HomePage/01-CreateOrderPage/TaxaOptions.tsx'

export const taxonLabel = (key: string) => taxaOptions.find((option) => option.value === key)?.label ?? key
